import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export enum RouteType {
  PublicOnly,
  PrivateOnly,
  PublicPrivate,

  // TODO: Refactor these out
  OnboardingParentRoute,
}

export type RouteDefinitionObject = {
  path: string;
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
  routeType: RouteType;
};
